var map = {
	"./moaf-character-man-1.png": 1161,
	"./moaf-cops-photo.png": 8786,
	"./moaf-cops.png": 393,
	"./moaf-darkman-light.png": 3542,
	"./moaf-darkman.png": 3873,
	"./moaf-vernissage-3-photo.png": 6728,
	"./moaf-woman-1.png": 9245,
	"./moaf-woman-2.png": 352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7756;